export default values => {
  if (values.callToAction.actionType) return values

  const { callToAction, ...rest } = values

  return rest
}
